import * as React from 'react';
import c from 'classnames';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { Icon } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink, DynamicMediaItem } from '@uncinc/react-drupal-core';

import { Card } from '../../../../components';
import type { TaxonomyTargetAudience } from '../../../../types/uncinc_profile/taxonomy';

interface TargetAudienceProps {
  entity: ImmutableEntity<TaxonomyTargetAudience>;
  aboveTheFold?: boolean;
}

const TaxonomyTargetAudienceTeaser: React.FC<TargetAudienceProps> = ({
  entity,
  aboveTheFold = false,
}) => {
  const classes = c('TaxonomyTargetAudienceTeaser');
  const targetAudience = entity.toJS();

  const language = targetAudience.langcode[0].value;
  const path = targetAudience.paths[language];
  const name = targetAudience.name[0].value;
  const media = targetAudience.field_media_item[0];

  return (
    <Card className={classes}>
      <Card.Content>
        <Card.Image image={<DynamicMediaItem media={media} imageAspectRatio="4_3" aboveTheFold={aboveTheFold} />} />

        <CoreLink href={path}>
          <div className="TargetAudienceCard__link">
            <Card.Title title={name} />
            <Icon name="chevron_right" />
          </div>
        </CoreLink>
      </Card.Content>
    </Card>
  );
};

export default TaxonomyTargetAudienceTeaser;
